var map = {
	"./background-left.png": 8323,
	"./background-right.png": 3290,
	"./bite_image_could_not_be_loaded.de.png": 2196,
	"./favicon.png": 292,
	"./icon-default-settings.svg": 2183,
	"./new-media-item.png": 9796,
	"./np_default-settings_230262_000000.svg": 3419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4550;